export const hizmetTipleri = ['Paketler', 'Cam Filmi', 'PPF Kaplama', 'Seramik Kaplama', 'Detay Temizlik', 'Yıkama', 'Göçük Düzeltme', 'Diğer'];

export const aracTurleri = ['Hatchback', 'Sedan', 'SUV', 'Station Wagon', 'Cabrio', 'Coupe', 'Ticari', 'Diğer'];

export const durumlar = ["Yeni Görüşme", "Taslak", "Müşteriye Dönüştü", "İptal Oldu"];

// Arşiv sekmesine düşen durumlar (tek kaynak).
export const arsivDurumlari = ["Müşteriye Dönüştü", "İptal Oldu"];

// Durum artık formdan elle seçilmiyor; yalnızca sekme/arşiv/dönüşüm akışı yazar.
// Canlıda v1'den kalma tanınmayan değerler var ('Yeni' ×6, 'Aranacak' ×2) — bunlar
// hiçbir sekmenin filtresine girmediği için kayıtlar uygulamada görünmez oluyordu.
// Güvenlik ağı: tanınmayan her durum 'Yeni Görüşme' gibi ele alınır (veri DEĞİŞMEZ,
// yalnız okuma normalize edilir; kalıcı düzeltme Faz 9 onarımında yapılacak).
export const normalizePreInterviewDurum = (durum) => (
    durumlar.includes(durum) ? durum : 'Yeni Görüşme'
);

// `normalizePreInterviewDurum` ile 'Yeni Görüşme'ye düşen durumların AÇIK listesi.
// Normalizasyon "tanınmayan her değer" kuralıyla çalışır; Firestore `in` sorgusu
// ise açık bir liste ister. Canlıdaki tanınmayan değerler Faz 1 teşhisinde tek tek
// sayıldı ('Yeni' ×6, 'Aranacak' ×2) — liste onlardan türetildi. Faz 9 onarımından
// sonra sorgu pratikte yalnız 'Yeni Görüşme' ile çalışacak; liste zararsız kalır.
export const yeniGorusmeDurumlari = ['Yeni Görüşme', 'Yeni', 'Aranacak'];

// Not girişinde tek tıkla eklenen hazır etiketler.
export const hizliNotEtiketleri = ['Fiyat sordu', 'Müsait değildi', 'Tekrar aranacak', 'Parça bekleniyor'];

// Randevu durumları AppointmentConstants.js'e taşındı (tek kaynak) — burada tutulmuyor.

export const camParts = ["Ön Sürüş Camı", "Arka Cam", "Ön Yan Camlar", "Arka Yan Camlar", "Sunroof", "Cam Tavan"];

export const seramikParts = ["Kaput", "Ön Tampon", "Arka Tampon", "Farlar", "Ön İki Çamurluk", "Arka İki Çamurluk", "Ön İki Kapı", "Arka İki Kapı", "Bagaj", "Tavan", "B/C Sütunları", "Kapı Tutacakları"];

export const ppfParts = [...seramikParts];

export const getStatusChipColor = (status) => {
    const colors = {
        'Yeni Görüşme': 'info',
        'Taslak': 'warning',
        'Müşteriye Dönüştü': 'success',
        'İptal Oldu': 'error',
        'Bekleniyor': 'info',
        'Onaylandı': 'success',
        'İptal': 'error',
        'Tamamlandı': 'primary'
    };
    return colors[status] || 'default';
};
